import { requestGet, requestPost } from '@/common/request';
import { ruleApi } from '@/apis';

export default {
  //2023年后端接口改造后，除了活动1.0的创建和更新还使用原接口之外，其余的都要用新接口
  async newActivityPlanAdd(query) {
    return await requestPost('/activityPlan/addActivityPlanByVer', query);
  },
  async newActivityPlanUpdate(query) {
    return await requestPost('/activityPlan/updateActivityPlanByVer', query);
  },
  // 获取活动级别权限
  async activityPlanLevel(query) {
    return await requestGet('/activityPlan/level', query);
  },
  // 获取部门、类目树
  async activityPlanOrganization(query) {
    return await requestGet('/activityPlan/organization', query);
  },
  // 活动可见查询
  async activityPlanVisibleSearch(query) {
    return await requestGet('/activityPlan/visible/search', query);
  },
  // 可见性部门删除
  async activityPlanVisibleDel(query) {
    return await requestGet('/activityPlan/visible/del', query);
  },
  // 可见性新增
  async activityPlanVisibleCreate(query) {
    return await requestPost('/activityPlan/visible/create', query);
  },
  // 活动盘品-获取规则信息
  async ruleGet(query) {
    return await requestGet('/rule/get', query);
  },
  async ruleGetAndGetRuleByType(query) {
    return await Promise.all([requestGet('/rule/get', query), ruleApi.getRuleByType({ ...query, type: 4 })]).then(
      ([res1, res2]) => {
        if (res1.ret === '0' && res2.ret === '0') {
          res1.data.poolInfo = res2.data;
          return res1;
        } else {
          const msg = res1.ret === '0' ? res2.msg : res2.ret === '0' ? res1.msg : res1.msg + res2.msg;
          return { ret: '-6', msg: msg || '网络错误请稍后重试', data: {} };
        }
      }
    );
  },
  // 活动邀请报名
  async activityPlanInvite(query) {
    return await requestGet('/activityPlan/invite', query);
  },
  async activityContractList(query) {
    return await requestGet('/activityContract/list', query);
  },
  async activityContractDelete(query) {
    return await requestGet('/activityContract/delete', query);
  },
  async activityContractCheckName(query) {
    return await requestGet('/activityContract/checkName', query);
  },
  async activityContractAdd(query) {
    return await requestPost('/activityContract/add', query);
  },
  async activityContractUpdate(query) {
    return await requestPost('/activityContract/update', query);
  },
  async activityContractGetDefault(query) {
    return await requestGet('/activityContract/getDefault', query);
  },
  async activityContractGet(query) {
    return await requestGet('/activityContract/get', query);
  },
  //校验主题活动es集群数据阈值
  async activityPlanValidEsCount(query) {
    return await requestGet('/activityPlan/validEsCount', query);
  },
  // 主题活动 - 设置主题保护关键词
  async activityPlanSetProtectedWords(query) {
    return await requestPost('/activityPlan/setProtectedWords', query);
  },
  // 主题活动 - 获取主题保护关键词
  async activityPlanGetProtectedWords(query) {
    return await requestGet('/activityPlan/getProtectedWords', query);
  },
  //主题活动 - 校验重复关键词
  async activityPlanValidateDupWords(query) {
    return await requestGet('/activityPlan/validateDupWords', query);
  },
  // 主题活动-买贵必赔活动创建可见性白名单
  async activityPlanCheckNewFlowErp(query) {
    return await requestGet('/activityPlan/checkNewFlowErp', query);
  },
  // 开发报名活动-资质保存
  async qualificationRefSave(query) {
    return await requestPost('/generic/mac/qualification/ref/save', query);
  },
  // 开发报名活动-资质查询
  async qualificationRefQuery(query) {
    return await requestGet('/generic/mac/qualification/ref/query', query);
  },
  // 打标商品规则校验保存
  async skuTagConfigSave4Promo(query) {
    return await requestPost('/skuTagConfig/save4Promo', query);
  },

  // 新增和修改活动对应的选品规则ID
  async activitySelectRuleSaveRule(query) {
    return await requestPost('/activitySelectRule/saveRule', query);
  },
  // 根据活动查询对应的选品规则ID
  async activitySelectRuleQuerySelectRuleId(query) {
    return await requestGet('/activitySelectRule/querySelectRuleId', query);
  },
  //--------商品价格资质校验------------
  //价格校验资质配置-查询场次列表
  async priceQuaTimeList(query) {
    return await requestGet('/activity/priceQuaTime/list', query);
  },
  //价格校验资质配置-新建场次
  async priceQuaTimeAdd(query) {
    return await requestPost('/activity/priceQuaTime/add', query);
  },
  //价格校验资质配置-编辑场次
  async priceQuaTimeUpdate(query) {
    return await requestPost('/activity/priceQuaTime/update', query);
  },
  //价格校验资质配置-删除场次
  async priceQuaTimeDel(query) {
    return await requestGet('/activity/priceQuaTime/del', query);
  },
  //价格校验资质配置-查询所有场次是否已经保存
  async priceQuaTimeIsAllSave(query) {
    return await requestGet('/activity/priceQuaTime/isAllSave', query);
  },
  //价格校验资质配置-上报场次是否已经保存
  async priceQuaTimeSaveReport(query) {
    return await requestGet('/activity/priceQuaTime/saveReport', query);
  },
  // 价格校验预跑配置-保存预跑时间
  async savePreRunTime(query) {
    return await requestGet('/activity/priceQuaTime/savePreRunTime', query);
  },
  // 价格校验预跑配置-查询预跑时间
  async queryPreRunTime(query) {
    return await requestGet('/activity/priceQuaTime/queryPreRunTime', query);
  },
  // 一键同步优惠券CMS
  async oneClickSyncCouponsCms(query) {
    return await requestGet('/activityPlan/oneClickSyncCouponsCms', query);
  },
  //主题活动绑定优惠券校验
  async checkCouponCms(query) {
    return await requestPost('/activityPlan/checkCoupon', query);
  },
  // 主题活动扩展字段保存
  async saveExtField(query) {
    return await requestPost('/activityPlan/saveExtField', query);
  },
  // 查询采销部门
  async querySelfVenderOrganization(query) {
    return await requestGet('/selfVenderSetting/organization', query);
  },
  // 保存采销部门
  async saveSelfVenderOrganization(query) {
    return await requestPost('/selfVenderSetting/organization4Save', query);
  },
  // 查询已存的采销部门
  async SelectedSelfVenderOrganization(query) {
    return await requestGet('/selfVenderSetting/organization4Selected', query);
  },
  // 校验有效活动
  async checkActivityValidity(query) {
    return await requestGet('/zongcu/checkActivityValidity', query);
  },
  // 综促联合打标报名-校验erp、venderId、shopId zcRelatedApply/checkDataValidity
  async checkDataValidity(query) {
    return await requestPost('/zcRelatedApply/checkDataValidity', query);
  },
  //查询综促报名打标规则设置
  async queryRelatedRule(query) {
    return await requestGet('/zcRelatedApply/queryRelatedRule', query);
  },
  //保存综促报名打标规则设置
  async addOrUpdateRelatedRule(query) {
    return await requestPost('/zcRelatedApply/addOrUpdateRelatedRule', query);
  },
  // 券批次ID有效性校验
  async checkCouponValidity(query) {
    return await requestGet('/activityPlan/checkCouponValidity', query);
  },
  //大促助手 - 根据planCode查询详情
  async salesHelperGetByPlanCode(query) {
    return await requestGet('/salesHelper/getByPlanCode', query);
  },
  async salesHelperAddV2(query) {
    return await requestPost('/salesHelper/addV2', query);
  },
  async salesHelperUpdateV2(query) {
    return await requestPost('/salesHelper/updateV2', query);
  },
  // 获取长期活动主活动数据列表
  async getLongActivityList() {
    return await requestGet('/trustee/getLongActivityList');
  },
};
